export function getIsWhiteLabel(state) {
  return state.user.isWhiteLabel;
}

export function getIsAdmin(state) {
  return state.user.isAdmin;
}
